module.exports = __webpack_public_path__ + "img/zf.c1d0eca2.png";